import multiApiClient from "./base";

export const KauflandApi = {
  // Fetch Kaufland credentials
  getKauflandCredentials: () => multiApiClient.get("/kaufland/credentials/"),

  // Create new Kaufland credential
  createKauflandCredential: (credential) =>
    multiApiClient.post("/kaufland/credentials/", credential),

  // Update Kaufland credential
  updateKauflandCredential: (id, credential) =>
    multiApiClient.put(`/kaufland/credentials/${id}`, credential),
  // Delete Kaufland credential
  deleteKauflandCredential: (id) =>
    multiApiClient.delete(`/kaufland/credentials/${id}`),

  // Test Kaufland credentials
  testKauflandCredentials: (id) =>
    multiApiClient.post(`/kaufland/credentials/${id}/test`),

  test_credentials_direct: (credentials) =>
    multiApiClient.post("/kaufland/credentials/test-direct", credentials),

  toggle_credential_status: (id) =>
    multiApiClient.post(`/kaufland/credentials/${id}/toggle_status`),
};
